import { Typography } from 'antd';
import Timeline, {
    TimelineHeaders,
    DateHeader,
    CustomMarker,
    TimelineMarkers,
} from 'react-calendar-timeline/lib';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/ja';
import 'react-calendar-timeline/lib/Timeline.css';
import './Timeline.css';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const groups = [{ id: 1, title: '' }];

const CustomTimeline = (props) => {
    const { i18n } = useTranslation();

    // Set moment locale based on current i18n language
    moment.locale(i18n.language === 'ja' ? 'ja' : 'en');
    moment.tz.setDefault('Asia/Tokyo');
    const today = moment();
    const startDate = today.clone().add(-2, 'days').toDate();
    const endDate = today.clone().add(26, 'days').toDate();

    // Dynamic month label format based on language
    const monthLabelFormat = i18n.language === 'ja' ? 'YYYY年 MMMM' : 'MMMM YYYY';
    // Dynamic day label format based on language
    const dayLabelFormat = i18n.language === 'ja' ? 'D dd' : 'dd D';

    const handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
        updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
    };

    const convertedData = (props.data || []).map((item) => ({
        ...item,
        start_time: moment(item.start_time).add(-1, 'day').startOf('day').toDate(),
        end_time: moment(item.end_time).add(-1, 'day').endOf('day').toDate(),
    }));

    const todayMarker = today
        .clone()
        .add(-1, 'day')
        .set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
        .toDate();

    return (
        <div style={{ marginBottom: '20px' }}>
            {props.title && (
                <div
                    style={{
                        borderBottom: '1px solid #f0f0f0',
                        paddingBottom: '10px',
                    }}
                >
                    <Title level={5} style={{ margin: 0 }}>
                        {props.title}
                    </Title>
                </div>
            )}
            <div>
                <Timeline
                    groups={groups}
                    items={convertedData}
                    defaultTimeStart={startDate}
                    defaultTimeEnd={endDate}
                    canMove={false}
                    canResize={false}
                    canChangeGroup={false}
                    onItemClick={(itemId, e, time) => {}}
                    onItemSelect={() => {}}
                    onTimeChange={handleTimeChange}
                    timeSteps={{ day: 1 }}
                    showCursorLine
                    sidebarWidth={0}
                    itemRenderer={({ item, itemContext, getItemProps }) => {
                        const style = {
                            background: item.color || 'transparent',
                            color: 'white',
                            boxSizing: 'border-box',
                            border:
                                item.borderColor && item.borderWidth
                                    ? `${item.borderWidth} solid ${item.borderColor}`
                                    : 'none',
                            marginTop: item.marginTop || '0px',
                            marginBottom: item.marginBottom || '0px',
                            padding: item.padding || '0px',
                        };
                        return (
                            <div {...getItemProps({ style })}>
                                <span>{item.title}</span>
                            </div>
                        );
                    }}
                >
                    <TimelineHeaders>
                        <DateHeader unit='month' labelFormat={monthLabelFormat} />
                        <DateHeader unit='day' labelFormat={dayLabelFormat} />
                    </TimelineHeaders>
                    <TimelineMarkers>
                        <CustomMarker date={todayMarker}>
                            {({ styles }) => {
                                const customStyles = {
                                    ...styles,
                                    backgroundColor: '#DC000C',
                                    width: '2px',
                                    zIndex: 100,
                                };
                                return (
                                    <div style={customStyles}>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: '-2px',
                                                width: '5px',
                                                height: '5px',
                                                backgroundColor: '#DC000C',
                                                borderRadius: '50%',
                                            }}
                                        />
                                    </div>
                                );
                            }}
                        </CustomMarker>
                    </TimelineMarkers>
                </Timeline>
            </div>
        </div>
    );
};

export default CustomTimeline;
